import React from 'react';
import PropTypes from 'prop-types';

import {
  MODERATOR,
  BILLER,
  JORNALIST,
  EDITOR,
  CORRECTOR,
  SUPERVISOR,
} from 'utils/roles';
import fullname from 'utils/fullname';

import withProfile from 'hocs/withProfile';
import Employees from 'api/resources/employees';
import { processErrorByAlert } from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';
import Alert from 'react-s-alert';

import RolesForm from 'admin-moderator/components/RolesForm';

import Avatar from 'components/Avatar';
import Popup from 'components/Popup';

import Button from 'styled/Buttons/PrimaryButton';
import SimpleButton from 'styled/Buttons/SimpleButton';

import ProfileStyled from './ProfileStyled';
import Logout from './Logout';
import Name from './Name';

const CAN_CHANGE_ROLES = ['localhost', 'staging-admin.baza.io'].indexOf(window.location.hostname) !== -1;

export class Profile extends React.PureComponent {
  state = {
    isPopupOpen: false,
    loading: false,
  }

  handlePopupOpen = () => {
    this.setState({ isPopupOpen: true });
  }

  handlePopupClose = () => {
    this.setState({ isPopupOpen: false });
  }

  handleLogout = () => {
    this.props.logout();
  }

  handleRolesChange = async (roles) => {
    this.setState({ loading: true });

    try {
      const response = await Employees.changeRoles({
        body: {
          data: {
            type: 'employee',
            attributes: {
              roles,
            },
          },
        },
        include: 'avatar',
      });

      this.setState({ loading: false });
      Alert.success('Роль сотрудника изменена');

      const profile = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.props.update(profile);
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <ProfileStyled>
        {!this.props.profile && (
          <div>Загрузка...</div>
        )}

        {this.props.profile && (
          <React.Fragment>
            <SimpleButton type="button" onClick={this.handlePopupOpen}>
              <Avatar
                name={fullname(this.props.profile)}
                size="64px"
                url={this.props.profile.avatar && this.props.profile.avatar.url}
              />
            </SimpleButton>

            <Popup
              isVisible={this.state.isPopupOpen}
              onClickOnBackdrop={this.handlePopupClose}
              isControlled
            >
              <Logout style={{ top: CAN_CHANGE_ROLES ? '-250px' : '-17px' }}>
                <Name>{fullname(this.props.profile)}</Name>

                <Button
                  type="button"
                  onClick={this.handleLogout}
                  style={{ width: '99px' }}
                  disabled={this.props.loading}
                >
                  Выйти
                </Button>

                {CAN_CHANGE_ROLES && (
                  <React.Fragment>
                    <hr style={{ width: '100%' }} />

                    <RolesForm
                      onRolesChange={this.handleRolesChange}
                      roles={this.props.profile.roles}
                      loading={this.state.loading}
                    />
                  </React.Fragment>
                )}
              </Logout>
            </Popup>
          </React.Fragment>
        )}
      </ProfileStyled>
    );
  }
}

Profile.propTypes = {
  profile: PropTypes.shape({
    avatar: PropTypes.shape({ url: PropTypes.string }),
    roles: PropTypes.arrayOf(
      PropTypes.oneOf([EDITOR, SUPERVISOR, MODERATOR, CORRECTOR, BILLER, JORNALIST])
    ),
  }),
  update: PropTypes.func,
  logout: PropTypes.func,
  loading: PropTypes.bool,
};

Profile.defaultProps = {
  profile: null,
  logout: () => {},
  update: () => {},
  loading: false,
};

export default withProfile(Profile);
